import { getLiveChatMp4Template, getVueLiveChatMp4Template } from "../../shortcodes/templates";

const visualizeLiveChatMp4 = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-mp4-shortcode"]');

  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      item.innerHTML = getLiveChatMp4Template();
    });
  }
};

const serializeLiveChatMp4 = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-mp4-shortcode"]');
  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      const liveChatData = item.getAttribute("data-live-chat-mp4-data");
      item.innerHTML = getVueLiveChatMp4Template(liveChatData);
    });
  }
};

export { visualizeLiveChatMp4, serializeLiveChatMp4 };
